import { View } from 'react-native';

// styles
import { styles } from './styles';
import { PressableNeolexon } from '@/components/PressableNeolexon';

export function Wrapper({
  onPress,
  isDisabled,
  hasIcon,
  isFirstIndex,
  children,
  hasBorder,
}) {
  return hasIcon ? (
    <View
      style={[hasBorder ? styles.border : !isFirstIndex && styles.topBorder]}
    >
      <PressableNeolexon
        style={{ opacity: isDisabled ? 0.6 : 1 }}
        disabled={isDisabled}
        onPress={onPress}
      >
        {children}
      </PressableNeolexon>
    </View>
  ) : (
    <View
      style={[hasBorder ? styles.border : !isFirstIndex && styles.topBorder]}
    >
      {children}
    </View>
  );
}
